import Player from '@vimeo/player';

const sections = document.querySelectorAll('.video-section');
if (sections.length > 0) {
    const handleVideoPlayer = (
        player,
        videoElement,
        videoPlay = null,
        disableInitPlay = false
    ) => {
        const videoId = videoElement.getAttribute('data-vimeo-video-id');
        if (!videoId) return;

        const videoPlayer = videoElement.querySelector('[data-vimeo-video]');
        const poster = videoElement.querySelector('.video-section__poster');

        player = new Player(videoPlayer, {
            id: videoId,
            responsive: true,
        });

        if (videoPlay && !disableInitPlay) player.play();
        player.on('play', function () {
            if (videoPlay) videoPlay.classList.add('-hide');
            videoPlayer.classList.add('-block');
            poster.classList.add('d-none');
        });
        player.on('pause', function () {
            if (videoPlay) videoPlay.classList.remove('-hide');
            videoPlayer.classList.remove('-block');
            poster.classList.remove('d-none');
        });
    };

    sections.forEach(section => {
        const videoElement = section.querySelector('[data-vimeo-video-id]');
        const videoPlay = section.querySelector('[data-vimeo-play]');
        let player = {};

        if (videoPlay) {
            if (section.classList.contains('-without-poster')) {
                handleVideoPlayer(player, videoElement, videoPlay, true);
            }
            videoPlay.addEventListener('click', e =>
                handleVideoPlayer(player, videoElement, videoPlay)
            );
        } else {
            handleVideoPlayer(player, videoElement, videoPlay);
        }
    });
}
